import { useRef, useState } from "react";
import { useLanguage } from "@/i18n";
import { Music, VolumeX } from "lucide-react";

export default function MusicToggle() {
  const { t } = useLanguage();
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = async () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio.volume = 0.55;
      try {
        await audio.play();
        setPlaying(true);
      } catch (e) { /* autoplay blocked */ }
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/assets/salsa.mp3" loop preload="none" />
      <button onClick={toggle} data-testid="music-toggle-button" aria-pressed={playing}
        className={`fixed bottom-5 right-5 z-50 flex items-center gap-2.5 rounded-full border px-5 py-3 backdrop-blur-xl transition-all duration-300 shadow-lg ${playing ? "border-sunset bg-sunset text-night" : "border-stroke bg-night/80 text-slate-200 hover:border-sunset hover:text-sunset"}`}>
        {playing ? <Music size={16} /> : <VolumeX size={16} />}
        <span className="text-sm font-semibold">{t.music.label}</span>
        {playing && (
          <span className="flex items-end gap-[3px] h-4" aria-hidden>
            <span className="w-[3px] bg-night rounded animate-[eq_0.7s_ease-in-out_infinite]" style={{ height: "60%" }} />
            <span className="w-[3px] bg-night rounded animate-[eq_0.9s_ease-in-out_infinite_0.15s]" style={{ height: "100%" }} />
            <span className="w-[3px] bg-night rounded animate-[eq_0.8s_ease-in-out_infinite_0.3s]" style={{ height: "40%" }} />
          </span>
        )}
      </button>
      <style>{`@keyframes eq { 0%,100% { transform: scaleY(0.4);} 50% { transform: scaleY(1);} }`}</style>
    </>
  );
}
